import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ThemeContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check localStorage first - respect saved preference
    const saved = localStorage.getItem('planblox-theme');
    if (saved) return saved;
    // No saved preference = first visit → default to dark
    return 'dark';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    localStorage.setItem('planblox-theme', theme);
  }, [theme]);

  // Sync with backend when user is logged in
  const syncThemeWithBackend = async (token) => {
    if (!token) return;
    try {
      const response = await axios.get(`${API}/me/preferences`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.theme && response.data.theme !== theme) {
        setTheme(response.data.theme);
      }
    } catch (error) {
      // Silently fail - user might not be logged in
    }
  };

  const toggleTheme = async () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    
    // Try to save to backend
    const token = localStorage.getItem('token');
    if (token) {
      try {
        await axios.put(`${API}/me/preferences`, 
          { theme: newTheme, emailNotifications: true },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error) {
        // Silently fail
      }
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, syncThemeWithBackend }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
